import makeStyles from '@mui/styles/makeStyles'
import React from 'react'

const useStyles: any = makeStyles(theme => ({
  invalid: {
    color: theme.palette.error.light,
  },
  valid: {
    color: theme.palette.success.light,
  },
}))

export const useOrderCoveredColorText = () => {
  const classes = useStyles()

  return (valid: boolean) => {
    if (valid === true) {
      return classes.valid
    }
    return classes.invalid
  }
}
